import { target } from "msem-lib/es/services/target.js";
import conf from "../config.json";
export default function configuration() {
    const env = target();
    if (!env) {
        throw new Error("Target environment is not defined");
    }
    return conf[env];
}
